import IssuerInvestmentsTable from 'apps/issuer/shared/investments-table';
import React, { FunctionComponent } from 'react';
export interface InvestmentTableViewProps {
  investorId: string;
}

const InvestmentTableView: FunctionComponent<InvestmentTableViewProps> = (props) => {
  const { investorId } = props;

  return <IssuerInvestmentsTable investorId={investorId} skipFilterUrlSync={true} hasPermission={true} />;
};

// TODO Try avoiding the repeated rerenders in the parent component (IssuerInvestorDetailsPage), rather than
// using React.memo to avoid the unnecessary calls to the server that the table is making
const MemoizedInvestmentTableView = React.memo(InvestmentTableView);
export default MemoizedInvestmentTableView;
